import { Button } from 'components'
import ModalWindow from 'hooks/ModalWindow/ModalWindow'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import styles from './ProfileOptionsModal.module.scss'

const ProfileOptionsModal = ({
  openModalOption,
  setOpenModalOption,
  isShown,
  isShownImg,
  setIsShownImg,
  setPassword,
  file,
  onFileChange,
  onChangeImage,
  onOpenPassword,
  onSubmitPassword,
  onOpenPin,
  onCloseAll,
  userId,
}) => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  return (
    <ModalWindow
      openModal={openModalOption}
      setOpenModal={setOpenModalOption}
      modalTitle={t('profile.options.profile_change')}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Button
          onClick={() => navigate('/personalcard')}
          className={styles.btn_pin}
        >
          {t('profile.options.personal_card')}
        </Button>

        {!isShownImg && (
          <Button
            onClick={() => setIsShownImg(true)}
            className={styles.btn_pin}
          >
            {t('profile.options.change_photo')}
          </Button>
        )}

        {isShownImg && (
          <div className={styles.info6}>
            {userId === undefined ? (
              <>
                <div className={styles.download}></div>
                <input
                  type="file"
                  className={styles.download}
                  accept="image/*"
                  onChange={onFileChange}
                  style={{ paddingTop: '7px' }}
                />
              </>
            ) : (
              ''
            )}
            {file === '' ? (
              ''
            ) : (
              <Button
                className={styles.btn2}
                onClick={() => {
                  onChangeImage({ file })
                }}
              >
                {t('profile.update')}
              </Button>
            )}
          </div>
        )}

        {!isShown && (
          <Button className={styles.btn_pin} onClick={onOpenPassword}>
            {t('profile.options.change_password')}
          </Button>
        )}
        {isShown && (
          <div className={`${styles.info6} unv-form`}>
            <label className="unv-field">
              <span className="unv-field__label">
                {t('profile.password.enter_new_password')}
              </span>
              <input
                type="password"
                autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)}
                className={`${styles.password_change} unv-input`}
              />
            </label>
            <Button className={styles.btn2} onClick={onSubmitPassword}>
              {t('profile.change')}
            </Button>
          </div>
        )}
        <Button onClick={onOpenPin} className={styles.btn_pin}>
          {t('profile.options.change_pin')}
        </Button>
      </div>

      <Button
        onClick={() => {
          onCloseAll()
          setOpenModalOption(false)
        }}
        className={styles.btn_pin_close_option}
      >
        {t('common.close')}
      </Button>
    </ModalWindow>
  )
}

export default ProfileOptionsModal
